export const REQUIRED_MARKETING_VIEW_COLUMNS = [
  { name: 'date', type: 'DATE' },
  { name: 'source', type: 'STRING' },
  { name: 'cost', type: 'FLOAT64' },
  { name: 'cost_in_usd', type: 'FLOAT64' },
];

const requiredColumnFromApi = (column) => ({
  name: column?.name || '',
  type: column?.type || column?.Type || '',
});

export const parseMarketingViewBaseSql = (data) => {
  const templateSql = data?.templateSql || data?.template_sql || '';
  const baseSql = data?.baseSql || data?.base_sql || templateSql;
  const apiColumns = data?.requiredColumns || data?.required_columns;
  const requiredColumns = Array.isArray(apiColumns) && apiColumns.length
    ? apiColumns.map(requiredColumnFromApi)
    : REQUIRED_MARKETING_VIEW_COLUMNS;

  return { baseSql, templateSql, requiredColumns };
};

export const parseMarketingViewValidation = (data) => ({
  isValid: Boolean(data?.isValid ?? data?.is_valid),
  errors: data?.errors || [],
  preview: (data?.preview || []).map((row) => ({
    month: row?.month,
    source: row?.source,
    defaultSpend: row?.defaultSpend ?? row?.default_spend,
    viewSpend: row?.viewSpend ?? row?.view_spend,
  })),
});

export const parseMarketingViewUpsert = (data) => ({
  marketingView: data?.marketingView || data?.marketing_view || null,
  errors: data?.errors || [],
});

export const MARKETING_VIEW_BQ_PREFIX = 'mv_';

export const marketingViewBqName = (marketingViewId) => {
  if (!marketingViewId) {
    return '';
  }
  return `${MARKETING_VIEW_BQ_PREFIX}${marketingViewId}`;
};

const MARKETING_VIEW_MONTHLY_FUNCTION_BASE = 'get_marketing_combined_monthly_by_date';
const MARKETING_VIEW_WEEKLY_FUNCTION_BASE = 'get_marketing_combined_weekly_by_date';

export const marketingViewFunctionNames = (marketingViewId) => {
  const bqName = marketingViewBqName(marketingViewId);
  if (!bqName) {
    return [];
  }
  return [
    `${MARKETING_VIEW_MONTHLY_FUNCTION_BASE}__${bqName}`,
    `${MARKETING_VIEW_WEEKLY_FUNCTION_BASE}__${bqName}`,
  ];
};

export const marketingViewInUseMessage = (view) => {
  const dealNames = (view?.dealNames || view?.deal_names || []).filter(Boolean);
  const usedByInstallment = Boolean(view?.usedByInstallment ?? view?.used_by_installment);
  if (!dealNames.length && !usedByInstallment && !view?.isUsed && !view?.is_used) {
    return '';
  }

  const usedBy = [];
  if (dealNames.length === 1) {
    usedBy.push(`deal ${dealNames[0]}`);
  } else if (dealNames.length > 1) {
    usedBy.push(`deals ${dealNames.join(', ')}`);
  }
  if (usedByInstallment || (!dealNames.length && (view?.isUsed || view?.is_used))) {
    usedBy.push('an installment');
  }
  if (!usedBy.length) {
    return 'This marketing view is used by a deal or installment and cannot be deleted.';
  }
  return `This marketing view is used by ${usedBy.join(' and ')} and cannot be deleted.`;
};

export const marketingViewDeleteMessage = (view) => {
  const name = view?.name || 'this marketing view';
  const bqName = marketingViewBqName(view?.id);
  const functionNames = marketingViewFunctionNames(view?.id);
  if (!bqName) {
    return `Delete ${name}? This also deletes its BigQuery view and functions and cannot be undone.`;
  }
  return `Delete ${name}? This also deletes BigQuery view ${bqName} and functions ${functionNames.join(' and ')}, and cannot be undone.`;
};

export const marketingViewEditorLabel = (view, getUserName) => {
  const userId = view?.updatedBy || view?.createdBy || '';
  if (!userId) {
    return '—';
  }
  const userName = typeof getUserName === 'function' ? getUserName(userId) : '';
  return userName || userId;
};
